// External links for de5.ai platform
export const EXTERNAL_LINKS = {
  // Communication
  telegram: "https://t.co/iLVsG7i5e1",
  telegramPartnership: "https://t.me/DegenXMan",
  support: "mailto:support@de5.ai",
  
  // Documentation
  documentation: "https://de5.gitbook.io/de5-docs/",
  keyFeatures: "https://de5.gitbook.io/de5-docs/key-features",
  institutions: "https://de5.gitbook.io/de5-docs/",
  
  // Social Media
  twitter: "https://x.com/dee5ai",
  
  // Platform
  website: "https://de5.ai",
  beta: "https://beta.de5.ai",
  waitlist: "/waitlist",
  contact: "/contact",
};
